import { createContext } from 'react';
export var ProvidersContext = /*#__PURE__*/createContext(null);
export var InlineCommentsStateContext = /*#__PURE__*/createContext({});